<div fxLayout="row" class="border-bottom datatable-header-cell-label">
    <div fxFlex="150px" class="py-1">
        <span class="p-1">Tipo Documento</span>
    </div>
    <div fxFlex="150px" class="py-1">
        <span class="p-1">Documento</span>
    </div>
    <div fxFlex="130px" class="py-1">
        <span class="p-1">Emissão</span>
    </div>
    <div fxFlex="150px" class="py-1">
        <span class="p-1">Vencimento</span>
    </div>
    <div fxFlex="140px" class="py-1" style="padding-left: 11px">
        <span class="p-1">Total</span>
    </div>
    <div fxFlex="130px" class="py-1" style="flex-grow:2">
        <span class="p-1">Emitido Por</span>
    </div>
    <div fxFlex="160px" class="py-1" style="flex-grow:2">
        <span class="p-1">Estado</span>
    </div>
    <div class="py-1" style="padding-left: 11px;flex-grow:2">
        <span class="p-1">Anexo</span>
    </div>
    <div *ngIf="false" fxFlex="60px" class="py-1" style="flex-grow:2">
        <span class="p-1"></span>
    </div>
</div>
<h3 *ngIf="documentos.length <= 0" class="datatable-header-cell-label" style="text-align: center"><b>Sem documentos para
    mostrar</b></h3>
<ng-container
        *ngFor="let doc of documentos"
        class="flex flex-y-center">
    <div fxLayout="row" class="border-bottom" style="max-height: 35px">
        <div fxFlex="150px" class="px-1 py-1 flex flex-y-center" style="text-align: justify">
            {{ doc.tipoDocumento }}
        </div>
        <a fxFlex="150px" class="hover-1 py-1 flex flex-y-center"
           [routerLink]="doc.url">
            <div><span class="p-1">{{ doc.codDocumento }}</span></div>
        </a>
        <div fxFlex="130px" class="py-1 flex flex-y-center">
            <span class="p-1">{{ doc.dataDocumento | date: 'dd-MM-yyyy' }}</span>
        </div>
        <div fxFlex="150px" class="py-1 flex flex-y-center">
            <span class="p-1">{{ doc.dataVencimento | date: 'dd-MM-yyyy' }}</span>
        </div>
        <div fxFlex="140px" class="py-1 flex flex-y-center text-right"
             style="padding-left: 11px;justify-content: end;">
            <span class="p-1">{{ doc.total | currency : '':'' }}</span>
        </div>
        <div fxFlex="130px" class="py-1 flex flex-y-center" style="flex-grow:2">
            <span class="p-1">{{ doc.utilizador?.username }}</span>
        </div>
        <div fxFlex="160px" class="py-1 flex flex-y-center" style="flex-grow:2">
            <mat-chip class="pr-1 pl-1 {{doc.codEstadoDocumento?.toUpperCase() === 'F' ? 'light-green-800 light-green-800-fg' :
                            (doc.codEstadoDocumento?.toUpperCase() === 'A' || doc.codEstadoDocumento?.toUpperCase() === 'T') ?
                            'red-A400 red-A400-fg': 'light-blue-700 light-blue-700-fg' }}" mat-sm-chip>
              {{ doc.estadoDocumento }}
            </mat-chip>
        </div>
        <div style="padding-left: 11px;flex-grow:2;max-width: 40px">
            <div class="hover-1 aln-1" (click)="downloadPDF(doc)">
                <app-pdf class="aln-1"></app-pdf>
            </div>
        </div>
        <div *ngIf="false" fxFlex="60px" class="py-1 flex flex-y-center" style="flex-grow:2;padding-left: 20px;">
            <button mat-icon-button type="button" (click)="anular(doc)"
                    matTooltip="Anular"
                    [disabled]="doc.codEstadoDocumento === 'A'"
                    [class.opacity-2]="doc.codEstadoDocumento === 'A'"
                    matTooltipClass="bg-secondary"
                    matTooltipPosition="above">
                <mat-icon class="mat-icon notranslate mat-warn material-icons">cancel</mat-icon>
            </button>
        </div>
    </div>
</ng-container>
